import React from 'react';
import img from '../../assets/OHM_1.png';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-800">
      {/* Header */}
      <header className="bg-white shadow-md">
        <div className="max-w-6xl mx-auto px-4 py-5 flex items-center justify-between">
          <a
            href="/"
            className="text-sm text-gray-600 hover:text-blue-600 transition"
          >
            <img src={img} className="w-[10dvw] h-[5dvh] object-fill" alt="" />
          </a>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-4 py-12">
        <h2 className="text-4xl font-extrabold mb-6">Privacy Policy</h2>
        <p className="text-sm text-gray-500 mb-8">
          Effective Date: March 17th, 2025
        </p>

        <section className="space-y-6">
          <p>
            OhmHub Inc. ("we," "us," or "our") respects your privacy and is
            committed to protecting it through this Privacy Policy. This Privacy
            Policy describes how we collect, use, disclose, and safeguard your
            information when you use our mobile application (the "App").
          </p>
          <p>
            By using our App, you agree to the collection and use of information
            in accordance with this Privacy Policy. If you do not agree with the
            terms of this policy, please do not use the App.
          </p>

          <h3 className="text-2xl font-semibold mt-8">
            1. Information We Collect
          </h3>

          <h4 className="font-semibold mt-4">
            A. Information You Provide to Us
          </h4>
          <ul className="list-disc pl-6">
            <li>
              Personal information such as name, email address, phone number,
              and account credentials.
            </li>
            <li>Payment and billing information, if applicable.</li>
            <li>
              Any other information you voluntarily provide when using the App.
            </li>
          </ul>

          <h4 className="font-semibold mt-4">
            B. Information Collected Automatically
          </h4>
          <ul className="list-disc pl-6">
            <li>
              Device and usage data including IP address, device type, OS, and
              app usage patterns.
            </li>
            <li>
              Cookies and tracking technologies for analytics and user
              experience.
            </li>
          </ul>

          <h4 className="font-semibold mt-4">
            C. Information from Third Parties
          </h4>
          <ul className="list-disc pl-6">
            <li>Data from services you link to the App.</li>
            <li>Social media login details, if used.</li>
          </ul>

          <h3 className="text-2xl font-semibold mt-8">
            2. How We Use Your Information
          </h3>
          <ul className="list-disc pl-6">
            <li>To operate, maintain, and improve our App.</li>
            <li>To personalize your experience and enhance support.</li>
            <li>To send updates, alerts, and promotions.</li>
            <li>To process payments (if applicable).</li>
            <li>To ensure technical functionality and security.</li>
          </ul>

          <h3 className="text-2xl font-semibold mt-8">
            3. Sharing and Disclosure of Information
          </h3>
          <p>We do not sell your personal data. We may share it only:</p>
          <ul className="list-disc pl-6">
            <li>
              With service providers for operations like hosting, analytics, and
              billing.
            </li>
            <li>As required by law or legal requests.</li>
            <li>During mergers or business transitions.</li>
          </ul>

          <h3 className="text-2xl font-semibold mt-8">4. Data Retention</h3>
          <p>
            We keep your data only as long as necessary to serve the purposes of
            this policy and fulfill legal obligations.
          </p>

          <h3 className="text-2xl font-semibold mt-8">
            5. Your Rights and Choices
          </h3>
          <ul className="list-disc pl-6">
            <li>Right to access, correct, or delete personal data.</li>
            <li>Right to withdraw consent where applicable.</li>
            <li>Right to opt out of marketing communications.</li>
            <li>
              Contact:{' '}
              <a
                href="mailto:info@ohmhub.net"
                className="text-blue-600 hover:underline"
              >
                info@ohmhub.net
              </a>
            </li>
          </ul>

          <h3 className="text-2xl font-semibold mt-8">
            6. Security of Your Information
          </h3>
          <p>
            We use industry-standard security measures. However, no method is
            100% secure over the internet.
          </p>

          <h3 className="text-2xl font-semibold mt-8">
            7. Third-Party Links and Services
          </h3>
          <p>
            We may link to third-party services. This policy does not apply to
            them — review their policies independently.
          </p>

          <h3 className="text-2xl font-semibold mt-8">8. Children's Privacy</h3>
          <p>
            We do not knowingly collect data from children under 13. If
            discovered, we will delete it immediately.
          </p>

          <h3 className="text-2xl font-semibold mt-8">
            9. Changes to This Privacy Policy
          </h3>
          <p>
            We may update this policy. Continued use means you accept the
            revised version.
          </p>

          <h3 className="text-2xl font-semibold mt-8">10. Contact Us</h3>
          <p>
            If you have any questions about this Privacy Policy, reach out at{' '}
            <a
              href="mailto:info@ohmhub.net"
              className="text-blue-600 hover:underline"
            >
              info@ohmhub.net
            </a>
            .
          </p>
        </section>
      </main>

      {/* Footer */}
      <footer className="text-center text-sm text-gray-400 py-6">
        © {new Date().getFullYear()} OhmHub Inc. All rights reserved.
      </footer>
    </div>
  );
};

export default PrivacyPolicy;
